import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderItemType from 'owa-service/lib/contract/AttachmentDataProviderItemType';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import handleGetItemsResponse from './handleGetItemsResponse';
import { GDriveDataProviderItemType } from '../constants';
import { GDriveItem, GDriveItemsResponse, getGDriveItems } from 'owa-fileprovider-services';
import {
    createAttachmentDataProviderItemsResponse,
    createFailedAttachmentDataProviderItemsResponse,
} from './createAttachmentDataProviderItemsResponse';

const FOLDER_MIME_TYPE = 'application/vnd.google-apps.folder';

export interface GDriveDataProviderItem extends AttachmentDataProviderItem {
    WebViewLink: string;
    FileExtension: string;
    CreatedTime: string;
}

export interface GDriveGetAttachmentDataProviderItemsResponse
    extends GetAttachmentDataProviderItemsResponse {
    NextPageToken: string;
}

function createAttachmentDataProviderItem(item: GDriveItem): GDriveDataProviderItem {
    const gDriveProviderItem: GDriveDataProviderItem = {
        __type: GDriveDataProviderItemType,
        Name: item.name,
        Size: parseInt(item.size),
        Thumbnail: {
            Url: item.thumbnailLink,
        },
        Preview: {
            // The thumbnailLink has information about size at the end of the string
            // So adding 2, makes the number much larger and will the max thumbnail size allowed
            Url: item.thumbnailLink + '2',
        },
        CreatedTime: item.createdTime,
        DownloadUrl: item.webContentLink,
        WebViewLink: item.webViewLink,
        FileExtension: item.fileExtension,
        Modified: item.modifiedTime,
        MimeType: item.mimeType,
        Location: item.id,
        Id: item.id,
        AttachmentProviderId: null,
        ProviderType: AttachmentDataProviderType.GDrive,
        Type:
            item.mimeType === FOLDER_MIME_TYPE
                ? AttachmentDataProviderItemType.Folder
                : AttachmentDataProviderItemType.File,
    };

    return gDriveProviderItem;
}

function createGDriveGetAttachmentDataProviderItemsResponse(
    getItemsResponse: GDriveItemsResponse
): GDriveGetAttachmentDataProviderItemsResponse {
    return {
        ...createAttachmentDataProviderItemsResponse(
            getItemsResponse.files,
            createAttachmentDataProviderItem
        ),
        NextPageToken: getItemsResponse.nextPageToken,
    };
}

function createFailedGDriveGetAttachmentDataProviderItemsResponse(
    errorCode: AttachmentResultCode
): GDriveGetAttachmentDataProviderItemsResponse {
    return {
        ...createFailedAttachmentDataProviderItemsResponse(errorCode),
        NextPageToken: null,
    };
}

export default async function getGDriveFileProviderItems(
    query: string,
    forceTokenRefresh: boolean = false
): Promise<GetAttachmentDataProviderItemsResponse> {
    const { errorResponse, result } = await getGDriveItems(query, forceTokenRefresh);

    if (result) {
        return handleGetItemsResponse(
            result,
            null /* errorResponse */,
            createGDriveGetAttachmentDataProviderItemsResponse,
            createFailedGDriveGetAttachmentDataProviderItemsResponse
        );
    } else {
        return handleGetItemsResponse(
            null /* result */,
            errorResponse,
            createGDriveGetAttachmentDataProviderItemsResponse,
            createFailedGDriveGetAttachmentDataProviderItemsResponse
        );
    }
}
